import { PercentageSquare } from 'iconsax-reactjs';
import type { FC } from 'react';
import { Badge, type BadgeProps } from './Badge';

/** The name of the trading fee tier a user is on. */
export const FeeTierBadge: FC<{
  name: string;
  size?: BadgeProps['size'];
  className?: string;
}> = ({ name, size = 4, className }) => (
  <Badge size={size} variant="primary" className={className}>
    <PercentageSquare size={12} variant="Bold" />
    {name}
  </Badge>
);
